import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query"

import { reportClientError } from "./client-error-reporting"

function queryKeyLabel(queryKey: readonly unknown[]): string {
  try {
    return JSON.stringify(queryKey)
  } catch {
    return "unserializable-query-key"
  }
}

/**
 * Shared QueryClient with global failure reporting. A query that only flips
 * an error state, or a mutation that toasts via `notifications.show` instead
 * of `notifyError`, still reaches diagnostics — call-site onError is not
 * required.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        reportClientError(error, {
          eventType: "client_query_error",
          title: queryKeyLabel(query.queryKey),
          context: { queryHash: query.queryHash },
        })
      },
    }),
    mutationCache: new MutationCache({
      onError: (error) => {
        reportClientError(error, { eventType: "client_mutation_error" })
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: true,
      },
    },
  })
}

export const queryClient = createQueryClient()
